import { render, staticRenderFns } from "./recActivityLog.vue?vue&type=template&id=d52c5bd8&"
import script from "./recActivityLog.vue?vue&type=script&lang=js&"
export * from "./recActivityLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports